import React, { useContext } from "react";
import { FaUserCheck, FaLightbulb, FaHandsHelping, FaBullhorn } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./behave.jpg";

const Behaviour: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/behaviour');
    } else {
      navigate('/login', { state: { from: '/booking/behaviour' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">General Safety</span>
          <h1 className="hero-title">Behavior Based Safety (BBS)</h1>
          <p className="hero-subtitle">
            Safety isn't just about rules—it's about people. Learn how psychology,
            observation, and positive reinforcement drive a zero-accident culture.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Understanding Behavioral Safety</h2>
              <p className="article-text">
                Behavior Based Safety (BBS) focuses on what people do, analyzing why they do it,
                and then intervening to encourage safe behavior. It recognizes that 80-90% of accidents
                are triggered by unsafe acts rather than unsafe conditions. By addressing the human element,
                we can prevent incidents before they start.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The ABC Model</h2>
              <p className="article-text">
                BBS often uses the ABC model: <strong>Activators</strong> (what triggers a behavior),
                <strong>Behavior</strong> (the action itself), and <strong>Consequences</strong>
                (what happens after). To change unsafe behavior, we often need to change the consequences—
                making safe behavior more rewarding than unsafe shortcuts.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Identifying Unsafe Acts</h2>
              <p className="article-text">
                Unsafe acts are warning signs. Whether it's skipping a checklist, rushing a job,
                or ignoring PPE, these small choices accumulate risk. A robust BBS program trains
                employees to observe peers non-judgmentally and provide constructive feedback.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Leadership's Role</h2>
              <p className="article-text">
                Leaders set the tone. If managers prioritize speed over safety, workers will too.
                Visible leadership—walking the floor, participating in observations, and praising
                safe acts—is the fuel for a positive safety culture.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Key Elements</h4>
              <ul className="key-list">
                <li><FaUserCheck className="check-icon" /> Peer-to-Peer Observation</li>
                <li><FaLightbulb className="check-icon" /> Root Cause Analysis</li>
                <li><FaHandsHelping className="check-icon" /> Positive Reinforcement</li>
                <li><FaBullhorn className="check-icon" /> Open Communication</li>
              </ul>
            </div>

            <div className="sidebar-widget">
              <h4 className="widget-title">Did You Know?</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                Positive reinforcement is 4x more effective at changing behavior than punishment.
                Catch people doing it right!
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Transform Your Culture</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Build a team that looks out for each other.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Behaviour;
